import { createContext, useState, useContext, useEffect, useCallback, useMemo } from 'react';
import translations from './translations.js';
import releaseCopy from './releaseCopy.js';

import { SUPPORTED_LANGUAGES, languageFromPath } from './routing.mjs';
export { SUPPORTED_LANGUAGES, languageFromPath, localePath } from './routing.mjs';
export const LanguageContext = createContext();
const aliases = { downloadPhotoStrip: 'download', takeNewPhotos: 'takeNew', shareOnSocialMedia: 'share', chooseLayoutStyle: 'layoutStyles', chooseBackgroundColor: 'backgroundColor', chooseFrameStyle: 'decorations' };
const lookup = (source, key) => key.split('.').reduce((value, part) => value && value[part], source);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => languageFromPath(window.location.pathname));
  const changeLanguage = useCallback(next => {
    if (!SUPPORTED_LANGUAGES.includes(next)) return;
    setLanguage(next);
    try { localStorage.setItem('picapica_language', next); } catch (_) { /* Storage may be disabled. */ }
  }, []);
  const t = useCallback((key, values = {}) => {
    const alias = aliases[key];
    const value = lookup(releaseCopy[language], key) ?? lookup(translations[language], key)
      ?? (alias ? lookup(translations[language], alias) : undefined)
      ?? lookup(releaseCopy.en, key) ?? lookup(translations.en, key)
      ?? (alias ? lookup(translations.en, alias) : undefined) ?? key;
    return typeof value === 'string' ? value.replace(/\{(\w+)\}/g, (match, name) => values[name] === undefined ? match : String(values[name])) : value;
  }, [language]);
  useEffect(() => { document.documentElement.lang = language; }, [language]);
  const value = useMemo(() => ({ language, changeLanguage, t }), [language, changeLanguage, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
export function useLanguage() {
  const value = useContext(LanguageContext);
  if (!value) throw new Error('useLanguage must be used within a LanguageProvider');
  return value;
}
export default { LanguageProvider, useLanguage };
